import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash/fp';
import PropTypes from 'prop-types';
import * as actions from 'actions/pathBuilder/contents';
import Fade from 'components/shared/animated/Fade';
import DebouncedTextArea from 'components/shared/debouncedTextArea';
import { routes, TYPES } from 'constants/config';
import useAutosize from 'hooks/useAutosize';
import request from 'utils/request_ajax';

const DemonstrationInfoCard = ({ demonstration, id, updateDemonstration }) => {
  const [title, setTitle] = useState(demonstration.title);
  const [description, setDescription] = useState(demonstration.description);
  const [error, setError] = useState(null);

  const onSave = (attributes = { title, description }) => {
    request
      .put(routes.UPDATE_DEMONSTRATION(id), {
        demonstration: attributes,
      })
      .then(response => {
        updateDemonstration(id, { ...attributes, id });

        if (response.success) {
          setError(null);
        }
      })
      .catch(e => {
        setError(e.responseJSON.error_message);
        console.error(e);
      });
  };

  const autosizeRef = useAutosize();
  const debouncedOnSave = useRef(debounce(300, onSave)).current;

  const handleTitleChange = value => {
    setTitle(value);
    debouncedOnSave({ title: value });
  };

  const handleDescriptionChange = value => {
    setDescription(value);
    debouncedOnSave({ description: value });
  };

  return (
    <div className="Card bg-white pt-32">
      <div className="d-f fd-c px-32 pb-32">
        <Fade in={error !== null}>
          <div className="ErrorContainer">{error}</div>
        </Fade>
        <DebouncedTextArea
          id="title"
          name="title"
          className="DemonstrationBuilderInput ff-ss fz-h1 lh-36 w-fill mb-24"
          onChange={handleTitleChange}
          placeholder={t(
            'demonstrations.demonstration_builder.title_placeholder',
          )}
          value={title}
          ref={autosizeRef}
          singleLine
        />
        <DebouncedTextArea
          id="description"
          name="description"
          className="DemonstrationBuilderInput ScenarioEditor-description fz-24 w-fill"
          onChange={handleDescriptionChange}
          placeholder={t('demonstrations.demonstration_builder.no_description')}
          value={description}
          ref={autosizeRef}
          singleLine
        />
      </div>
    </div>
  );
};

DemonstrationInfoCard.propTypes = {
  demonstration: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  id: PropTypes.number,
  updateDemonstration: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateDemonstration: (id, demonstration) =>
    dispatch(actions.update(id, TYPES.DEMONSTRATION, demonstration)),
});

export default connect(null, mapDispatchToProps)(DemonstrationInfoCard);
